module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAnCAMAAACltJG0AAAAS1BMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////+DmQsHAAAAGHRSTlMAor0LtsnCq+XXmpCC3dGIJxTyeW9jHFixzW3QAAAAw0lEQVQ4y+2SzQ6DIBAGP8R/bdVWLe//pE12Eze44nLsoXMxyAQCDC5Y3YYsXAhhyBRZtUWmzxRttQmCuxNLUsq54m9aLEgoABgqizVgqTWvqEbprS2Vt2vUPVSI8U8RT2rno5+d3KB6hoePVxRRq8shHisqepppPYhFROnzpO4ktjSYEn2ONPuagZ3FIRIvVT7MeNPnm48FvXVCpdBGo8+Vw5ncZvb5cYP/9/lLfRJGn4LZp2D2KVh9anSfmrs+NdLnF3OCKiu4626+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/up.png
// module id = QbRH
// module chunks = 1